'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _CwToolbar = require('./CwToolbar.scss');

var _CwToolbar2 = _interopRequireDefault(_CwToolbar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CwToolbar = function (_Component) {
  (0, _inherits3.default)(CwToolbar, _Component);

  function CwToolbar() {
    (0, _classCallCheck3.default)(this, CwToolbar);
    return (0, _possibleConstructorReturn3.default)(this, (CwToolbar.__proto__ || (0, _getPrototypeOf2.default)(CwToolbar)).apply(this, arguments));
  }

  (0, _createClass3.default)(CwToolbar, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { 'data-cwid': this.props.cwId, className: _CwToolbar2.default.toolbar },
        _react2.default.createElement(
          'div',
          { className: _CwToolbar2.default.overflowButtons },
          this.props.overflowButtons
        ),
        this.props.rightButtons ? _react2.default.createElement(
          'div',
          { className: _CwToolbar2.default.rightButtons },
          this.props.rightButtons
        ) : null
      );
    }
  }]);
  return CwToolbar;
}(_react.Component);

exports.default = CwToolbar;


CwToolbar.propTypes = {
  /**
   * Connectwise element id to be used as unique identifier
   */
  cwId: _propTypes2.default.string,
  overflowButtons: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.element), _propTypes2.default.element]),
  rightButtons: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.element), _propTypes2.default.element])
};


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui/lib/components/cwtoolbar/CwToolbar.js
// module id = 864
// module chunks = 10